import { PayloadAction } from '@reduxjs/toolkit';

import { ENROLL_METHOD } from '../../models/enroll';
import { ENROLL_AUTH_REQUEST_TYPE } from '../../models/enroll-requests';
import { isOneOf } from '../../util/DataHelpers';
import { EnrollSuccessPayload } from '../common-actions';

export function checkEnrollActionType(action: PayloadAction<EnrollSuccessPayload>) {
  const { callName } = action.payload;

  const isTaxDetailsCall = (
    callName === ENROLL_METHOD[ENROLL_METHOD.postIndividualTaxDetailOwnBatch]
    || callName === ENROLL_METHOD[ENROLL_METHOD.putIndividualTaxDetailOwn]
    || callName === ENROLL_METHOD[ENROLL_METHOD.deleteTaxDetail]
  );

  const isRegisterDocumentCall = isOneOf(callName, [
    ENROLL_METHOD[ENROLL_METHOD.postIndividualDocumentOwn],
    ENROLL_METHOD[ENROLL_METHOD.postDocumentOwnBinary],
  ]);

  const isAcceptLegalDeclarationsCall = callName === ENROLL_METHOD[ENROLL_METHOD.putIndividualOwnLegalDeclarations];

  const isPhoneVerifiedCall = ENROLL_AUTH_REQUEST_TYPE[callName.split('/')[1] as keyof typeof ENROLL_AUTH_REQUEST_TYPE]
    === ENROLL_AUTH_REQUEST_TYPE.VERIFY_PHONE_CODE;

  return {
    isTaxDetailsCall,
    isRegisterDocumentCall,
    isAcceptLegalDeclarationsCall,
    isPhoneVerifiedCall,
  };
}
